export default {"src":"/_next/static/media/Set-Up-Wallet.ed9b8b87.svg","height":373,"width":500};